export enum PurchaseContentType {
  Post = 'post',
  NftListing = 'nft_listing',
}
